/*
 *细节列表功能
 */
import DetailsList from '../../components/detailsList';

function setDetailsList(params) {
  // if (!params) return;
  this.detailsList = new DetailsList({
    wrapper: this.$container.get(0),
    data:params,
    onDetailsClick: data => {
      this.changeSceneView(data);
    },
  });
}

function showDetailsList() {
  if (!this.detailsList) return;
  this.detailsList.show();
  this.sceneList.hide();
}

function hideDetailsList() {
  if (!this.detailsList) return;
  this.detailsList.hide();
}

function onDetailsBtnClick() {
  if (!this.detailsList) return;
  this.detailsList.toggle();
  this.sceneList.hide();
}

export default {
  setDetailsList,
  showDetailsList,
  hideDetailsList,
  onDetailsBtnClick
};